import SellerNavbar from "./Navbar/Navbar_Seller";
import SellerProducts from "./Seller_product";

export default function SellerDashboard() {
    
  return (
    <>
      <SellerNavbar />

      <SellerProducts />
    </>
  );
}
